import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

export default withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={15}
    defaultCenter={{ lat: props.lat, lng: props.lng }}
    >
    <Marker position={{ lat: props.lat, lng: props.lng }} />
  </GoogleMap>
));



// WEBPACK FOOTER //
// ./src/components/GoogleMap.js